import { createSelector } from 'reselect'

const muvicardInterestRateSelector = ({ muvicardInterestRate }) =>
	muvicardInterestRate
const muvicardInstallmentsOptionsSelector = ({ muvicardInstallmentsOptions }) =>
	muvicardInstallmentsOptions
const muvicardInstallmentsQttSelector = ({ muvicardInstallmentsQtt }) =>
	muvicardInstallmentsQtt

const getMuvicardInterestRate = createSelector(
	[muvicardInterestRateSelector],
	(muvicardInterestRate) => muvicardInterestRate
)

const getMuvicardInstallmentsOptions = createSelector(
	[muvicardInstallmentsOptionsSelector],
	(muvicardInstallmentsOptions) => muvicardInstallmentsOptions
)

const getMuvicardInstallmentsQtt = createSelector(
	[muvicardInstallmentsQttSelector],
	(muvicardInstallmentsQtt) => muvicardInstallmentsQtt
)

const Selectors = {
	getMuvicardInterestRate,
	getMuvicardInstallmentsOptions,
	getMuvicardInstallmentsQtt,
}

export default Selectors
